export function academicGrade(score) {
  if (score >= 90) return "A";
  if (score >= 80) return "B";
  if (score >= 70) return "C";
  return "D";
}

export function academicIndicatorStatus(value) {
  if (
    (typeof value !== "number" && typeof value !== "string") ||
    (typeof value === "string" && value.trim() === "") ||
    !Number.isFinite(Number(value)) ||
    Number(value) < 0 ||
    Number(value) > 100
  ) return null;

  const score = Number(value);
  return {
    label: academicGrade(score),
    color: score >= 80 ? "#48B920" : "#D84343",
    backgroundColor: score >= 80 ? "#DDF3D5" : "#FFE0E0",
    style: score >= 80 ? "consistent" : "missing",
  };
}

export function deriveAcademicData(statistic, period) {
  const grouped = new Map();
  (statistic?.summary_materials || [])
    .filter((item) => item.periode === period)
    .forEach((item) => {
      const indicators = (item.materialDetail || []).flatMap((detail) =>
        Object.entries(detail.indicator || {})
          .filter(([, value]) =>
            value !== null &&
            !(typeof value === "string" && value.trim() === "") &&
            (typeof value === "number" || typeof value === "string") &&
            Number.isFinite(Number(value)) &&
            Number(value) >= 0 &&
            Number(value) <= 100,
          )
          .map(([name, value]) => ({
            name,
            value: Number(value),
            category: item.material,
            characterName: detail.character,
            label: academicGrade(Number(value)),
          })),
      );
      grouped.set(item.material, [...(grouped.get(item.material) || []), ...indicators]);
    });
  const materialGroups = [...grouped].map(([name, indicators]) => ({ name, indicators }));
  const subjects = materialGroups
    .filter((group) => group.indicators.length > 0)
    .map((group) => {
      const score = group.indicators.reduce((total, item) => total + item.value, 0) /
        group.indicators.length;
      return { name: group.name, score, grade: academicGrade(score) };
    })
    .sort((a, b) => b.score - a.score);
  const indicators = materialGroups.flatMap((group) => group.indicators);
  const sortedIndicators = [...indicators].sort((a, b) => b.value - a.value);
  const positive = sortedIndicators.filter((item) => item.value >= 80).slice(0, 3);
  const attention = [...sortedIndicators].reverse()
    .filter((item) => item.value < 80).slice(0, 3);

  return {
    subjects,
    subjectTotal: materialGroups.length,
    average: subjects.length
      ? subjects.reduce((total, item) => total + item.score, 0) / subjects.length
      : null,
    highest: subjects[0],
    lowest: subjects[subjects.length - 1],
    gradeCounts: ["A", "B", "C", "D"].map((grade) => ({
      grade,
      count: subjects.filter((item) => item.grade === grade).length,
    })),
    materialItems: { positive, attention },
    materialGroups,
  };
}
